import { render, staticRenderFns } from "./font-select.vue?vue&type=template&id=563d532c&scoped=true&"
import script from "./font-select.vue?vue&type=script&lang=js&"
export * from "./font-select.vue?vue&type=script&lang=js&"
import style0 from "./font-select.vue?vue&type=style&index=0&id=563d532c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d532c",
  null
  
)

export default component.exports